// This is the amount of card the user will see that is slightly off screen to indicate that it can be
// scrolled.
export const reelVisibleAdjacentCardOffset = 32; // 2rem
